import { ref } from 'vue';

const eventBus = ref([]);

export const useEventBus = () => eventBus;